import { isObject, pick } from 'lodash'

// Spreadsheets evaluate cells starting with these as formulas (CSV injection), even when quoted.
const FORMULA_START = /^[=+\-@\t\r\n]/
// Plain numbers ("-5", "+1.5"), phone numbers ("+1 (570) 555-0134") and a lone "-" placeholder
// can't exfiltrate anything, so leave them readable instead of prefixing them.
const SAFE_VALUE = /^[-+]?\d+(\.\d+)?$|^\+\d[\d\s\-().]*$|^-$/

const neutralizeFormula = (text) =>
  FORMULA_START.test(text) && !SAFE_VALUE.test(text) ? `'${text}` : text

export const parseToCsv = ({ data, headers }) => {
  const csvData = []

  // Use the labels of the headers for the CSV
  const formatField = (field) => `"${neutralizeFormula(String(field)).replace(/"/g, '""')}"`
  const headersToWrite = headers.map((header) => formatField(header.label))
  csvData.push(headersToWrite.join(','))

  // Remove any unnecessary properties from the rows
  const allowedProperties = headers.map((header) => header.accessor)
  const rows = data.map((row) => pick(row, allowedProperties))

  // Format any rows if necessary
  rows.forEach((row) => {
    const formattedRow = []
    headers.forEach((header) => {
      const property = header.accessor
      const value = row[property]

      const formattedValue =
        value == null
          ? '""' // Ensure empty values are represented as ""
          : formatField(
              header.format
                ? header.format(value)
                : isObject(value)
                  ? JSON.stringify(value)
                  : String(value)
            )

      formattedRow.push(formattedValue)
    })

    csvData.push(formattedRow.join(','))
  })

  return csvData.join('\n')
}
